import { COUNTRY_LANGUAGE_LIST } from '../../common/webSiteLanguages';

const ALL_COUNTRIES = Object.keys(COUNTRY_LANGUAGE_LIST);
export const featuredMapInvestors = {
  0: {
    countries: [],
    name: 'Forbes',
    alt: 'Forbes',
    img: 'forbes_logo',
    link: 'https://www.forbes.com/sites/tobyshapshak/2019/10/15/nigerian-sme-digital-lender-lidya-expands-to-europe/#37257ea249b7',
    description: 'Nigerian SME Digital Lender. Lidya Expands to Europe.',
    target: '_blank',
  },
  1: {
    countries: ALL_COUNTRIES,
    name: 'FinTech Futures',
    alt: 'FinTech Futures',
    img: 'fintech_logo',
    link: 'https://www.fintechfutures.com/2020/10/nigerian-fintech-lidya-lends-3m-to-smes-in-eastern-europe/',
    description: 'Nigerian fintech Lidya lends $3m to SMEs in Eastern Europe.',
    target: '_blank',
  },
  2: {
    countries: ALL_COUNTRIES,
    name: 'Bloomberg',
    alt: 'Bloomberg',
    img: 'bloomberg_logo',
    link: 'https://www.bloomberg.com/news/articles/2019-10-14/nigerian-fintech-lidya-targets-1-1-billion-in-east-europe-loans',
    description:
      'Nigerian Fintech Firm Targets $1.1 Billion in Eastern Europe Loans.',
    target: '_blank',

  },
};
export const featuredMap = {
  // TODO: uncomment this when needed
  /* 0: {
    countries: ALL_COUNTRIES,
    name: 'Lidya',
    alt: 'Lidya',
    img: 'lidya_logo',
    link: '/news/communication/',
    description: 'website.news.title',
    isLidya: true,
  }, */
  1: {
    countries: [],
    name: 'Bloomberg',
    alt: 'Bloomberg',
    img: 'bloomberg_logo',
    link: 'https://www.bloomberg.com/news/articles/2019-10-14/nigerian-fintech-lidya-targets-1-1-billion-in-east-europe-loans',
    target: '_blank',
    description: 'Nigerian Fintech Firm Targets $1.1 Billion in Eastern Europe Loans.',
  },

  2: {
    countries: [],
    name: 'Forbes',
    alt: 'Forbes',
    img: 'forbes_logo',
    link: 'https://www.forbes.com/sites/tobyshapshak/2019/10/15/nigerian-sme-digital-lender-lidya-expands-to-europe/#37257ea249b7',
    target: '_blank',
    description: 'Nigerian SME Digital Lender Lidya Expands to Europe.',
  },

  3: {
    countries: [COUNTRY_LANGUAGE_LIST.ng.code, COUNTRY_LANGUAGE_LIST.pl.code],
    name: 'HBS Alumni Maganzine',
    alt: 'Harvard Unversity',
    img: 'hbs_logo',
    link: 'https://www.alumni.hbs.edu/stories/Pages/story-bulletin.aspx?num=7176',
    target: '_blank',
    description: 'Capitalizing The Corner Shop.',
  },

  4: {
    countries: [COUNTRY_LANGUAGE_LIST.ng.code, COUNTRY_LANGUAGE_LIST.us.code],
    name: 'CNN',
    alt: 'CNN',
    img: 'cnn_logo',
    link: 'https://edition.cnn.com/videos/business/2020/03/24/tunde-kehinde-lidya-technology-africa-mpa.cnn/video/playlists/marketplace-africa-pre-roll/',
    target: '_blank',
    description: 'How one company is hoping to help small businesses thrive in Africa.',
  },

  5: {
    countries: [COUNTRY_LANGUAGE_LIST.cz.code],
    name: 'Seznam zpravy',
    alt: 'Seznam zpravy',
    img: 'seznam_zpravy_logo',
    link: 'https://www.seznamzpravy.cz/clanek/podnikatele-slysi-casteji-ne-u-banky-i-alternativni-pujcky-ale-zprisnily-150748#utm_content=ribbonnews&utm_term=lidya&utm_medium=hint&utm_source=search.seznam.cz',
    target: '_blank',
    description: 'Podnikatelé slyší častěji „ne“ u banky. I alternativní půjčky ale zpřísnily.',

  },

  6: {
    countries: [COUNTRY_LANGUAGE_LIST.cz.code],
    name: 'MF DNES',
    alt: 'DNES',
    img: 'dnes_logo',
    link: 'https://www.idnes.cz/ekonomika/domaci/fintech-lidya-start-up-pujcky-nigerie.A191219_522149_ekonomika_svob',
    target: '_blank',
    description: 'Nigerijská firma půjčí Čechům, chce zde rozpůjčovat pět miliard korun.',
  },

  7: {
    countries: [COUNTRY_LANGUAGE_LIST.cz.code],
    name: 'Hospodářské Noviny',
    alt: 'Hospodářské Noviny',
    img: 'hn_logo',
    link: 'https://archiv.hn.cz/c1-66997500-start-up-nigerijskeho-internetoveho-podnikatele-kehindeho-nabizi-pujcky-malym-ceskym-firmam',
    target: '_blank',
    description: 'Start-up nigerijského internetového podnikatele Kehindeho nabízí půjčky malým českým firmám.',
  },

  8: {
    countries: [COUNTRY_LANGUAGE_LIST.pl.code, COUNTRY_LANGUAGE_LIST.us.code],
    name: 'EuroMoney',
    alt: 'EuroMoney',
    img: 'euromoney_logo',
    link: 'https://www.euromoney.com/article/b1ll0sm83wcn7s/cee-fintechs-step-up-as-consumers-dump-cash.',
    target: '_blank',
    description: 'CEE fintechs step up as consumers dump cash',
  },

  9: {
    countries: [COUNTRY_LANGUAGE_LIST.ng.code, COUNTRY_LANGUAGE_LIST.us.code],
    name: 'CNBC Africa',
    alt: 'CNBC Africa',
    img: 'cnbc_africa_logo',
    link: 'https://www.cnbcafrica.com/videos/2019/10/15/how-this-nigeria-based-sme-lending-platform-plans-to-create-100mn-jobs-in-fast-growing-economies/',
    target: '_blank',
    description: 'How this Nigeria-based SME lending platform plans to create 100mn jobs in fast-growing economies.',
  },

  10: {
    countries: [COUNTRY_LANGUAGE_LIST.cz.code],
    name: 'Seznam zpravy',
    alt: 'Seznam zpravy',
    img: 'seznam_zpravy_logo',
    link: 'https://www.seznamzpravy.cz/clanek/nigerijsky-startup-lidya-ziskal-180-milionu-bude-pujcovat-v-cesku-170737#utm_content=ribbonnews&utm_term=lidya&utm_medium=hint&utm_source=search.seznam.cz',
    target: '_blank',
    description: 'Nigerijci expandují v Česku. Na půjčky malým firmám dostal startup miliony.',
  },

  11: {
    countries: [COUNTRY_LANGUAGE_LIST.cz.code],
    name: 'Czech Crunch',
    alt: 'Czech Crunch',
    img: 'czechcrunch_logo',
    link: 'https://cc.cz/z-nigerie-expandovala-do-ceska-a-za-rok-a-pul-poskytla-uvery-za-150-milionu-korun-ted-lidya-nabrala-investici-180-milionu/',
    target: '_blank',
    description: 'Nigerijský startup v Česku rozjel úvěry pro menší firmy a sám teď od investorů získává dalších 180 milionů.',
  },

  12: {
    countries: [COUNTRY_LANGUAGE_LIST.cz.code],
    name: 'METRO',
    alt: 'METRO',
    img: 'metro_news_logo',
    link: 'https://www.metro.cz/lidya-se-spojila-se-shoptetem-reaguji-na-prudky-rozvoj-e-commerce-p9c-/protext.aspx?c=A211201_151400_metro-protext_wei',
    target: '_blank',
    description: 'Lidya se spojila se Shoptetem, reagují na prudký rozvoj e-commerce.',
  },
};
